module.exports = require('./dist')



//////////////////
// WEBPACK FOOTER
// ./~/coolors-to-hex/index.js
// module id = 398
// module chunks = 97291517795586 114276838955818